module.exports = __webpack_public_path__ + "img/weather17.1f49609a.png";